module.exports = __webpack_public_path__ + "Lato-Black.d2d9ddbd08ae0ade29ce.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Black.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Black.eot
// module chunks = styles